import { InternalBankTransferFormModel } from '@/modules/banking/models'

const ACTION_PREFIX = 'banking/internalBankTransfer'
const HIDE_DRAWER = `${ACTION_PREFIX}/hideDrawer`
const SHOW_DRAWER = `${ACTION_PREFIX}/showDrawer`
const SET_FORM_DATA = `${ACTION_PREFIX}/setFormData`
const SET_ORIGIN_BOOKING = `${ACTION_PREFIX}/setOriginBooking`
const SET_ORIGIN_BANK_ACCOUNT = `${ACTION_PREFIX}/setOriginBankAccount`
const RESET_STATE = `${ACTION_PREFIX}/resetState`
const SET_SELECTED_BOOKING = `${ACTION_PREFIX}/setSelectedBooking`
const SET_SELECTED_BANK_ACCOUNT = `${ACTION_PREFIX}/setSelectedBankAccount`

const initialState = {
  // Identifier bank account from which the transfer should be started
  originBankAccountId: null,
  // Identifier of the booking that should be transfered
  originBookingId: null,
  // Formdata for the creation of a transfer booking
  formData: new InternalBankTransferFormModel(),
  // Identifier of the bank account selected as transfer target (assignment)
  selectedBankAccountId: null,
  // Identifier of the booking selected as transfer target (assignment)
  selectedBookingId: null,
  // State of the transfer drawer
  open: false,
}

export default function internalBankTransferReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_DRAWER: {
      return { ...state, open: true }
    }
    case HIDE_DRAWER: {
      return { ...state, open: false }
    }
    case SET_FORM_DATA: {
      const { formData } = action

      return { ...state, formData: new InternalBankTransferFormModel({ ...state.formData, ...formData }) }
    }
    case SET_ORIGIN_BOOKING: {
      const { bookingId } = action

      return {
        ...state,
        originBookingId: bookingId,
      }
    }
    case SET_ORIGIN_BANK_ACCOUNT: {
      const { bankAccountId } = action
      return {
        ...state,
        originBankAccountId: bankAccountId,
      }
    }
    case SET_SELECTED_BOOKING: {
      const { bookingId } = action

      return {
        ...state,
        selectedBookingId: bookingId,
      }
    }
    case SET_SELECTED_BANK_ACCOUNT: {
      const { bankAccountId } = action
      return {
        ...state,
        selectedBankAccountId: bankAccountId,
      }
    }
    case RESET_STATE: {
      return {
        ...initialState,
      }
    }
    default: {
      return state
    }
  }
}

export const hideInternalBankTransferDrawer = () => ({ type: HIDE_DRAWER })
export const showInternalBankTransferDrawer = () => ({ type: SHOW_DRAWER })
export const setInternalBankTransferFormData = formData => ({ type: SET_FORM_DATA, formData })
export const setInternalBankTransferOriginBooking = bookingId => ({ type: SET_ORIGIN_BOOKING, bookingId })
export const setInternalBankTransferOriginBankAccount = bankAccountId => ({ type: SET_ORIGIN_BANK_ACCOUNT, bankAccountId })
export const setInternalBankTransferSelectedBooking = bookingId => ({ type: SET_SELECTED_BOOKING, bookingId })
export const setInternalBankTransferSelectedBankAccount = bankAccountId => ({ type: SET_SELECTED_BANK_ACCOUNT, bankAccountId })
export const resetState = () => ({ type: RESET_STATE })
